/**
 * This flag is not specified on the Backend. It is being used to hide the
 * net new Project fields on the Org Creation form: project name and timezone.
 * Until these fields are added to the BE endpoint /admin/newOrganizationReact
 * they will be excluded from the form.
 * */
export const ORG_FORM_PROJECT_FIELDS = true;
